/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import { withPropertyData } from "../../../../components/property-admin-data-provider";
import { withUserAuthInfo } from "../../../../lib/auth";

function evalProp({ field, propName, formValues, entity, showAdvancedTranslations, userInfo }) {
  if (field.hasOwnProperty(propName)) {
    const prop = field[propName];
    let value = prop;
    if (typeof prop === "function") {
      value = prop({ formValues, entity, showAdvancedTranslations, userInfo });
    }

    return value;
  }

  return undefined;
}

function transformField({ field, propName, formValues, entity, locale, wbkData, userInfo }) {
  if (field.hasOwnProperty(propName)) {
    const prop = field[propName];

    if (typeof prop === "function") {
      return prop({ field, propName, formValues, entity, locale, wbkData, userInfo });
    }

    return field;
  }
}

function asFormField(WrappedComponent) {
  const Result = class extends React.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {}
    render() {
      const { field, formValues, entity, showAdvancedTranslations, locale, userInfo } = this.props;
      const checkProp = propName =>
        evalProp({ entity, formValues, field, propName, showAdvancedTranslations, userInfo });
      const isVisible = checkProp("visible") === undefined ? true : !!checkProp("visible");

      const readOnly =
        typeof field.readOnly === "function"
          ? Boolean(field.readOnly({ formValues }))
          : Boolean(entity.id) && Boolean(field.readOnly);

      if (!isVisible) {
        return null;
      }
      const isDisabled = !!checkProp("disabled");
      const fieldCloneFirst = {
        ...field,
        displayName: checkProp("displayName"),
        helpText: checkProp("helpText"),
      };
      const transformedField = transformField({
        entity,
        formValues,
        field,
        locale,
        propName: "transform",
        wbkData: this.props.wbkData,
        userInfo,
      });
      const fieldClone = { ...fieldCloneFirst, ...transformedField };
      const rendererType = fieldClone.widget || null;
      return (
        <WrappedComponent
          {...this.props}
          disabled={isDisabled}
          field={fieldClone}
          readOnly={readOnly}
          rendererType={rendererType}
        />
      );
    }
  };

  return withPropertyData(withUserAuthInfo(Result));
}

export default asFormField;
